import type { XlsxField } from '../interfaces/xlsx-field';

export const BASE_PARAMETERS_IMPORT_FIELDS: XlsxField[] = [
  {
    key: 'adrClasses',
    name: 'labels.adrClass',
  },
  {
    key: 'hooksNumber',
    name: (translateService) =>
      `${translateService.instant('labels.hooks')} (${translateService.instant('units.pieces').toLowerCase()})`,
  },
  {
    key: 'matsNumber',
    name: (translateService) =>
      `${translateService.instant('labels.mats')} (${translateService.instant('units.pieces').toLowerCase()})`,
  },
  {
    key: 'temperatureRangeFrom',
    name: (translateService) =>
      `${translateService.instant('labels.temperatureRange')} (${translateService.instant('labels.from').toLowerCase()}) [°C]`,
  },
  {
    key: 'temperatureRangeTo',
    name: (translateService) =>
      `${translateService.instant('labels.temperatureRange')} (${translateService.instant('labels.to').toLowerCase()}) [°C]`,
  },
  {
    key: 'hasLoadingsRamps',
    name: (translateService) =>
      `${translateService.instant('labels.loadingRamps')}?`,
  },
  {
    key: 'hasHaccp',
    name: (translateService) => `${translateService.instant('labels.haccp')}?`,
  },
  {
    key: 'hasHdsCrane',
    name: (translateService) =>
      `${translateService.instant('labels.hdsCrane')}?`,
  },
  {
    key: 'hasCustomsSecuringRope',
    name: (translateService) =>
      `${translateService.instant('labels.customsSecuringRope')}?`,
  },
  {
    key: 'beltsNumber',
    name: (translateService) =>
      `${translateService.instant('labels.belts')} (${translateService.instant('labels.quantity').toLowerCase()})`,
  },
  {
    key: 'hasSanitaryInspection',
    name: (translateService) =>
      `${translateService.instant('labels.sanitaryInspection')}?`,
  },
  {
    key: 'hasTailLift',
    name: (translateService) =>
      `${translateService.instant('labels.tailLift')}?`,
  },
  {
    key: 'hasDumpContainer',
    name: (translateService) =>
      `${translateService.instant('labels.dumpContainer')}?`,
  },
  {
    key: 'hasForklift',
    name: (translateService) =>
      `${translateService.instant('labels.forklift')}?`,
  },
  { key: 'otherVehicleParameters', name: 'labels.otherVehicleParameters' },
];
